import { FilterCollectionStore, RemoteCollectionStore, SortCollectionStore, StoreBuilder } from "@softline/core";
import { AbteilungUebersicht } from "../types/abteilung";

export const PmsAbteilungStore = new StoreBuilder(RemoteCollectionStore.create<AbteilungUebersicht>())
  .add(FilterCollectionStore.create<AbteilungUebersicht>())
  .add(SortCollectionStore.create<AbteilungUebersicht>())
  .value;